/**
 * @generated SignedSource<<226caae816a72cc750c6a61ba6513f64>>
 * @relayHash 5086ae5cc41ad90e4bf31df6f518da91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 17d3d3e19f0d4901ed3d0458409adee524a9413d1de05f49f567e993d05981b1

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewUpdatesAsideAggRootQuery$variables = {
  containerId: string;
  directoryId: string;
};
export type SavedViewUpdatesAsideAggRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewSidebarColumnAgg">;
};
export type SavedViewUpdatesAsideAggRootQuery = {
  response: SavedViewUpdatesAsideAggRootQuery$data;
  variables: SavedViewUpdatesAsideAggRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "directoryId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "directoryId",
    "variableName": "directoryId"
  }
],
v3 = [
  {
    "alias": "uuid",
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "entityType"
  },
  {
    "kind": "ScalarField",
    "name": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "SavedViewSidebarColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "TownsquareDirectoryView",
        "kind": "LinkedField",
        "name": "goals_directoryViewById",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "args": (v2/*: any*/),
        "concreteType": "TownsquareDirectoryView",
        "kind": "LinkedField",
        "name": "projects_directoryViewById",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "directoryViewId",
            "variableName": "directoryId"
          }
        ],
        "concreteType": "TownsquareSearchExplanation",
        "kind": "LinkedField",
        "name": "projects_explainSearch",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "logSafeQuery"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "17d3d3e19f0d4901ed3d0458409adee524a9413d1de05f49f567e993d05981b1",
    "metadata": {},
    "name": "SavedViewUpdatesAsideAggRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2404c4e290a08bd2d8b50064047c93d9";

export default node;
